export default {
  protocols: [],
  protocolsLoaded: false
}
